import { Form, Button } from "antd";
import { showSuccess, showError } from "infra/helpers/alerta";
import { useOperacaoOrdemServicoTalhoes } from "../../../hooks/useGetHistoricoPlanejamentoOperacao";
import useModal from "../../../hooks/useModalPlanejamentoOperacoes";
import { SelectAntd, CustomModal, Textarea, ButtonSend } from "./styles";
import { MdEditNote } from "react-icons/md";
import URL from 'core/resources/urls';
import { useQueryClient } from "react-query";
import { useFilters } from "core/features/filters/store";

interface ModalEncerrarOuReabrirProps {
  refetch: () => void;
}

const { Item, useForm } = Form;

function ModalEncerrarOuReabrir({ refetch }: ModalEncerrarOuReabrirProps) {

  const { mutateAsync: update, isLoading } = useOperacaoOrdemServicoTalhoes();
  const {
    setIds,
    isEncerrarOuReabrirModal,
    setIsEncerrarOuReabrirModal,
    planoOperacionalOperacaoTalhao,
    setPlanoOperacionalOperacaoTalhao,
    talhaoId,
    codigoEncerrarOuReabrirModal,
    setCodigoEncerrarOuReabrirModal
  } = useModal();
  const [form] = useForm();
  const { filters: { filtersAdvanced } } = useFilters();
  const queryClient = useQueryClient();

  async function onFinish() {
    try {
      const id = planoOperacionalOperacaoTalhao?.planoOperacionalOperacaoTalhaoId;
      const payload = {
        ...form.getFieldsValue(),
        tipoAlteracao: codigoEncerrarOuReabrirModal,
        planoOperacionalOperacaoTalhaoIds: [id]
      }

      const response = await update({ body: payload });

      if (response.status === 204) {
        showSuccess("Operação cancelada com sucesso!");
        setPlanoOperacionalOperacaoTalhao(null);
        queryClient.invalidateQueries([URL.PLANO_OPERACIONAL.OBTER_LISTA_POR_TALHAO, talhaoId, { safraPeriodoId: filtersAdvanced.safraPeriodo }]);
        queryClient.invalidateQueries([URL.PLANO_OPERACIONAL.OBTER_HISTORICO_TALHAO_ORDEM_SERVICO, talhaoId]);
        refetch();
        closedModal();
        return;
      }
    } catch (e) {
      const details = (e as any).response.data.Details;
      const error = details[0].Errors[0];
      showError(error);
      console.log(error);
    }
  }

  function closedModal() {
    setIsEncerrarOuReabrirModal(false);
    setIds([]);
    setCodigoEncerrarOuReabrirModal(null);
    form.resetFields();
  }

  const listMotivos = [
    { label: "Selecione um motivo", value: "" },
    { label: "Climático", value: 0 },
    { label: "Decisão Agronômica", value: 1 },
    { label: "Problema Operacional", value: 2 },
    { label: "Capacidade Operacional", value: 3 },
    { label: "Outros (novo)", value: 4 },
  ];

  const colorTheme = codigoEncerrarOuReabrirModal === 6 ? "#f39c12" : "#27ae60";

  return (
    <CustomModal
      title={
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <MdEditNote size={24} />
          {codigoEncerrarOuReabrirModal === 5 ? "Encerrar" : "Reabrir"} Operação
        </span>
      }
      visible={isEncerrarOuReabrirModal}
      onCancel={closedModal}
      backgroundColor={colorTheme}
      maskClosable={false}
      className="teste"
      footer={
        <>
          <Button
            size="large"
            loading={isLoading}
            onClick={closedModal}
            style={{ borderRadius: 8 }}
          >Cancelar</Button>
          <ButtonSend
            size="large"
            type="primary"
            danger
            loading={isLoading}
            onClick={() => form.submit()}
            backgroundColor={colorTheme}
          >Confirmar</ButtonSend>
        </>
      }
    >
      <div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Item
            label="Motivo"
            name="motivo"
            rules={[{ required: true, message: "Campo Motivo é obrigatório" }]}
          >
            <SelectAntd
              options={listMotivos}
            />
          </Item>
          <Item
            label="Observação"
            name="observacao"
            rules={[{ required: true, message: "Campo Observação é obrigatório" }]}
          >
            <Textarea
              placeholder="Descreva os detalhes da justificativa..."
              maxLength={200}
            ></Textarea>
          </Item>
        </Form>
      </div>
    </CustomModal>
  );
}

export default ModalEncerrarOuReabrir;
